const theme = {
  media: {
    sm: `screen and (max-width: 640px)`,
    md: `screen and (max-width: 768px)`,
    lg: `screen and (max-width: 1024px)`,
    xl: `screen and (max-width: 1280px)`,
    '2xl': `screen and (max-width : 1560px)`,
  },
}

export default theme
